module.exports = __webpack_public_path__ + "static/media/note-1-color.3995cfa3.svg";